import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const ReachIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="reach-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7643 11.9654C14.0786 8.76224 14.0786 5.53319 13.7643 2.33007C13.6522 1.18786 12.4102 0.609269 11.5411 1.29437L8.64255 3.57903C7.75932 4.27521 6.68808 4.65115 5.58757 4.65115H2.88291C2.39529 4.65115 2 5.0703 2 5.58736V8.70807C2 9.22512 2.39529 9.64428 2.88291 9.64428H3.32385L2.72675 12.0072C2.66022 12.2705 2.78157 12.5465 3.01456 12.6617L5.61465 13.9474C5.75657 14.0175 5.92049 14.0175 6.06241 13.9474C6.20433 13.8772 6.3097 13.744 6.35023 13.5837L7.2421 10.0542C7.25157 10.0167 7.25724 9.97908 7.25934 9.94179C7.75199 10.1222 8.2189 10.3825 8.64255 10.7164L11.5411 13.0011C12.4102 13.6862 13.6522 13.1076 13.7643 11.9654ZM12.7105 2.44634C13.0172 5.57215 13.0172 8.72328 12.7105 11.8491C12.6834 12.1252 12.3832 12.265 12.1731 12.0994L9.27461 9.81476C8.20865 8.97455 6.91577 8.52082 5.58757 8.52082L3.05949 8.52082L3.05949 5.7746H5.58757C6.91578 5.7746 8.20865 5.32088 9.27461 4.48067L12.1731 2.196C12.3832 2.03041 12.6834 2.17026 12.7105 2.44634ZM6.24287 9.68891C6.02645 9.6593 5.80759 9.64428 5.58757 9.64428H4.42071L3.86519 11.8427L5.49024 12.6463L6.21871 9.76342C6.22522 9.73766 6.23332 9.71279 6.24287 9.68891Z"
      fill="currentColor"
    />
  </Icon>
);
